var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 24,
    viewBox: "0 0 61 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1318_4470)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.6619 2.41692C28.6928 1.58407 29.0629 0.936298 29.7724 0.473602C30.5127 0.103447 31.253 0.103447 31.9933 0.473602C32.7028 0.936298 33.073 1.58407 33.1038 2.41692C33.073 3.24977 32.7028 3.89755 31.9933 4.36024C31.253 4.7304 30.5127 4.7304 29.7724 4.36024C29.0629 3.89755 28.6928 3.24977 28.6619 2.41692ZM30.5127 16.4829V22.4054C30.5127 22.8372 30.3739 23.1919 30.0963 23.4696C29.8187 23.7472 29.4639 23.886 29.0321 23.886C28.6002 23.886 28.2455 23.7472 27.9679 23.4696C27.6903 23.1919 27.5515 22.8372 27.5515 22.4054V12.0873L26.2097 14.3082C25.9937 14.6475 25.7007 14.8634 25.3305 14.956C24.9295 15.0485 24.5594 14.9868 24.2201 14.7709C23.8499 14.555 23.6186 14.2619 23.526 13.8918C23.4335 13.4908 23.4952 13.1206 23.7111 12.7813L26.3947 8.29315C26.7957 7.61453 27.3355 7.07472 28.0142 6.67372C28.6928 6.30356 29.4177 6.11849 30.1888 6.11849H31.5769C32.3789 6.11849 33.1038 6.30356 33.7516 6.67372C34.4302 7.07472 34.97 7.61453 35.371 8.29315L38.1009 12.7813C38.286 13.1206 38.3323 13.4908 38.2397 13.8918C38.1472 14.2619 37.9313 14.555 37.592 14.7709C37.2218 14.9868 36.8362 15.0485 36.4352 14.956C36.0651 14.8634 35.772 14.6475 35.5561 14.3082L34.2143 12.0873V22.4054C34.2143 22.8372 34.0755 23.1919 33.7979 23.4696C33.5202 23.7472 33.1655 23.886 32.7337 23.886C32.3018 23.886 31.9471 23.7472 31.6695 23.4696C31.3918 23.1919 31.253 22.8372 31.253 22.4054V16.4829H30.5127Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1318_4470"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 23.69,
    fill: "white",
    transform: "matrix(1 0 0 -1 0.882812 23.886)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3);
export default __webpack_public_path__ + "static/media/icon-3.5cdd661d3f5b1d5a54b2627b84c55fc2.svg";
export { ForwardRef as ReactComponent };